import Typography from '@ixigo/iui/Typography';
import { LeftStar } from './LeftStar';
import { RightStar } from './RightStar';

export const UspItem = ({ title }: { title: string }) => {
	return (
		<div className="flex items-center justify-center gap-x-5">
			{/* Todo: needs to fix stars size */}
			<LeftStar className="w-7 h-3.5" />
			<Typography variant="body-sm" fontWeight="medium">
				{title}
			</Typography>
			<RightStar className="w-7 h-3.5" />
		</div>
	);
};
